import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useToast } from "../../contexts/ToastContext";
import leaveService from "../../services/leaveService";
import { getErrorMessage } from "../../utils/errorHandler";

import Navbar from "../../components/layout/Navbar";
import Sidebar from "../../components/layout/Sidebar";
import PageHeader from "../../components/ui/PageHeader";
import StatCard from "../../components/ui/StatCard";
import LeaveBalanceCards from "../../components/common/LeaveBalanceCards";
import LeaveRequestTable from "../../components/common/LeaveRequestTable";
import CalendarPreview from "../../components/common/CalendarPreview";

import {
  Plus,
  Calendar,
  Clock,
  CheckCircle2,
  FileText,
  Bell,
  ChevronRight,
} from "lucide-react";

import { useNavigate } from "react-router-dom";

import "../../styles/dashboard.css";

const EmployeeDashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();

  const [balances, setBalances] = useState(null);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [holidays, setHolidays] = useState([]);
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const balanceData =
          await leaveService.getLeaveBalancesMe();

        const requestData =
          await leaveService.getLeaveRequestsMe();

        setBalances(balanceData);
        setRequests(
          Array.isArray(requestData)
            ? requestData
            : []
        );
      } catch (err) {
        console.error(
          "Error fetching dashboard data:",
          err
        );

        toast.error(getErrorMessage(err));
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [toast]);

  /* =========================================================
     LOADING
  ========================================================= */

  if (loading) {
    return (
      <div className="dashboard-layout-container">
        <Navbar />

        <div className="dashboard-content-wrapper">
          <Sidebar />

          <main
            className="dashboard-main-content"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "60vh",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <div
                className="calendar-loading-spinner"
                style={{
                  width: "40px",
                  height: "40px",
                  border: "3px solid var(--border)",
                  borderTopColor: "var(--primary)",
                  borderRadius: "50%",
                  margin: "0 auto 16px",
                }}
              />

              <p
                style={{
                  color: "var(--text-muted)",
                  fontSize: "0.9rem",
                }}
              >
                Chargement de vos données...
              </p>
            </div>
          </main>
        </div>
      </div>
    );
  }

  /* =========================================================
     DATA
  ========================================================= */

  const safeRequests = Array.isArray(requests)
    ? requests
    : [];

  const approvedRequests = safeRequests.filter(
    (r) => r?.status === "APPROVED"
  );

  const pendingRequests = safeRequests.filter(
    (r) =>
      r?.status === "PENDING_MANAGER" ||
      r?.status === "PENDING_HR"
  );

  /* =========================================================
     CALENDAR DATA
  ========================================================= */

  const calendarRequests = safeRequests.map((req) => ({
    id: req?.id,
    employeeName: req?.employee_name,
    startDate: req?.start_date,
    endDate: req?.end_date,
    type: req?.leave_type_name,
    status:
      req?.status === "APPROVED"
        ? "Approuvé"
        : req?.status === "REJECTED"
        ? "Refusé"
        : "En attente",
  }));

  /* =========================================================
     RENDER
  ========================================================= */

  return (
    <div className="dashboard-layout-container">
      <Navbar />

      <div className="dashboard-content-wrapper">
        <Sidebar />

        <main
          className="dashboard-main-content"
          style={{ padding: "24px" }}
        >

          {/* =================================================
              HEADER
          ================================================= */}

          <PageHeader
            title={`Bonjour, ${
              user?.name || "Collaborateur"
            } 👋`}
            subtitle="Consultez votre espace personnel, vos congés, vos contrats et vos alertes."
            actions={
              <button
                onClick={() =>
                  navigate("/employee/leave-create")
                }
                className="btn btn-primary"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Plus size={18} />

                <span>
                  Demander un congé
                </span>
              </button>
            }
          />

          {/* =================================================
              MON ESPACE PERSONNEL
          ================================================= */}

         {/* section
            style={{
              marginBottom: "28px",
            }}
          >
            <div
              className="ui-card"
              style={{
                padding: "20px",
              }}
            >
              <div
                style={{
                  marginBottom: "18px",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: "700",
                    color: "var(--text-main)",
                    margin: 0,
                  }}
                >
                  Mon espace personnel
                </h3>

                <p
                  style={{
                    marginTop: "6px",
                    marginBottom: 0,
                    color: "var(--text-muted)",
                    fontSize: "0.9rem",
                  }}
                >
                  Accédez rapidement à vos contrats et à
                  vos alertes.
                </p>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "repeat(auto-fit, minmax(260px, 1fr))",
                  gap: "16px",
                }}
              >

                {/* ==============================
                    MES CONTRATS
                ============================== */}

               {/*utton
                  type="button"
                  onClick={() =>
                    navigate("/rh/my-contracts")
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "16px",
                    width: "100%",
                    padding: "18px 20px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "14px",
                    background: "#ffffff",
                    cursor: "pointer",
                    textAlign: "left",
                    transition:
                      "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor =
                      "#4f46e5";

                    e.currentTarget.style.boxShadow =
                      "0 4px 14px rgba(79,70,229,0.12)";

                    e.currentTarget.style.transform =
                      "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor =
                      "#e2e8f0";

                    e.currentTarget.style.boxShadow =
                      "none";

                    e.currentTarget.style.transform =
                      "translateY(0)";
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "14px",
                    }}
                  >
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#eef2ff",
                        color: "#4f46e5",
                        flexShrink: 0,
                      }}
                    >
                      <FileText size={23} />
                    </div>

                    <div>
                      <div
                        style={{
                          fontSize: "15px",
                          fontWeight: "700",
                          color: "#0f172a",
                        }}
                      >
                        Mes contrats
                      </div>

                      <div
                        style={{
                          marginTop: "4px",
                          fontSize: "12px",
                          color: "#64748b",
                        }}
                      >
                        Consulter mes contrats
                        de travail
                      </div>
                    </div>
                  </div>

                  <ChevronRight
                    size={20}
                    color="#94a3b8"
                  />
                </button>*/}

                {/* ==============================
                    MES ALERTES
                ============================== */}

                 {/* on
                  type="button"
                  onClick={() =>
                    navigate("/rh/employee-alerts")
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "16px",
                    width: "100%",
                    padding: "18px 20px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "14px",
                    background: "#ffffff",
                    cursor: "pointer",
                    textAlign: "left",
                    transition:
                      "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor =
                      "#f59e0b";

                    e.currentTarget.style.boxShadow =
                      "0 4px 14px rgba(245,158,11,0.12)";

                    e.currentTarget.style.transform =
                      "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor =
                      "#e2e8f0";

                    e.currentTarget.style.boxShadow =
                      "none";

                    e.currentTarget.style.transform =
                      "translateY(0)";
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "14px",
                    }}
                  >
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#fef3c7",
                        color: "#d97706",
                        flexShrink: 0,
                      }}
                    >
                      <Bell size={23} />
                    </div>

                    <div>
                      <div
                        style={{
                          fontSize: "15px",
                          fontWeight: "700",
                          color: "#0f172a",
                        }}
                      >
                        Mes alertes
                      </div>

                      <div
                        style={{
                          marginTop: "4px",
                          fontSize: "12px",
                          color: "#64748b",
                        }}
                      >
                        Consulter mes alertes
                        et notifications
                      </div>
                    </div>
                  </div>

                  <ChevronRight
                    size={20}
                    color="#94a3b8"
                  />
                </button>

              </div>
            </div>
          </section>*/}

          {/* =================================================
              QUICK STATS
          ================================================= */}

          <section
            style={{
              marginBottom: "28px",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fit, minmax(220px, 1fr))",
                gap: "16px",
              }}
            >

           { /*  <StatCard
                title="Solde Congés Payés"
                value={`${Number(
                balances?.balances_by_type?.["ANNUEL"] ??
                balances?.balances_by_type?.["annual_balance"] ??
                0
              )} jours`}
                subtitle="Calculé hors jours fériés"
                icon={Calendar}
                iconBg="var(--primary-light)"
                iconColor="var(--primary)"
              />*/}

              <StatCard
                title="En Attente"
                value={pendingRequests.length}
                subtitle="En cours de validation"
                icon={Clock}
                iconBg="#fef3c7"
                iconColor="#d97706"
                onClick={() =>
                  navigate("/employee/leave-history")
                }
              />

              <StatCard
                title="Congés Approuvés"
                value={approvedRequests.length}
                subtitle="Validés cette année"
                icon={CheckCircle2}
                iconBg="var(--secondary-light)"
                iconColor="var(--secondary)"
                onClick={() =>
                  navigate("/employee/leave-history")
                }
              />

            </div>
          </section>

          {/* =================================================
              BALANCES
          ================================================= */}

          <section
            style={{
              marginBottom: "28px",
            }}
          >
            <div
              className="ui-card"
              style={{
                padding: "20px",
              }}
            >
              <h3
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "700",
                  color: "var(--text-main)",
                  marginBottom: "16px",
                }}
              >
                Mes Soldes de Congés Restants
              </h3>

              
                  <LeaveBalanceCards
                    balancesByType={balances?.balances_by_type || {}}
                    monthsWorked={balances?.months_worked}
                    hireDate={balances?.hire_date}
                    annualBalanceN1={
                      balances?.annual_balance_n1 ??
                      balances?.remaining_n1
                    }
                    annualBalanceN={
                      balances?.annual_balance_n ??
                      balances?.remaining_n
                    }
                    annualTotalRemaining={
                      balances?.annual_balance ??
                      balances?.annual_total_remaining ??
                      balances?.total_remaining
                    }
                  />

            </div>
          </section>

          {/* =================================================
              DEMANDES RÉCENTES
          ================================================= */}

          <section
            style={{
              marginBottom: "28px",
            }}
          >
            <div
              className="ui-card"
              style={{
                padding: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent:
                    "space-between",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: "700",
                    color: "var(--text-main)",
                    margin: 0,
                  }}
                >
                  Mes Demandes Récentes
                </h3>

                <button
                  onClick={() =>
                    navigate(
                      "/employee/leave-history"
                    )
                  }
                  className="btn btn-outline"
                  style={{
                    fontSize: "0.85rem",
                  }}
                >
                  Voir l'historique
                </button>
              </div>

              <LeaveRequestTable
                requests={safeRequests.slice(0, 5)}
                role="employee"
              />
            </div>
          </section>

          {/* =================================================
              CALENDRIER
          ================================================= */}

          <section
            style={{
              marginBottom: "28px",
            }}
          >
            <div
              className="ui-card"
              style={{
                padding: "20px",
              }}
            >
              <h3
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "700",
                  color: "var(--text-main)",
                  marginBottom: "16px",
                }}
              >
                Mon Planning des congés
              </h3>

              <CalendarPreview
                requests={calendarRequests}
                 showEmployeeName={true}
              />
            </div>
          </section>

        </main>
      </div>
    </div>
  );
};

export default EmployeeDashboard;